import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateProjectBrandVoicesForBrandTerms($id: Int!, $brandVoiceIdsForBrandTerms: [ID!]) {
    updateProject(id: $id, brandVoiceIdsForBrandTerms: $brandVoiceIdsForBrandTerms) {
      id
    }
  }
`;

export const updateProjectBrandVoicesForBrandTerms = ({ id, brandVoiceIdsForBrandTerms }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id, brandVoiceIdsForBrandTerms },
  }).then(({ data }) => getSingleProp(data));
